import { render, staticRenderFns } from "./RepairItem.vue?vue&type=template&id=1aff9978&"
import script from "./RepairItem.vue?vue&type=script&lang=js&"
export * from "./RepairItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports